(() => {
	const initSliders = () => {
		const slideshows = document.querySelectorAll(".guides__container");
		slideshows.forEach((slideshow) => {
			const slideshowSwiper = new Swiper(slideshow, {
				autoHeight: false,
				allowTouchMove: true,
                slidesPerView: 'auto',
                spaceBetween: 10,
				centerInsufficientSlides: true,
                pagination: {
                    el: ".guides__pagination",
                    clickable: true,
                  },
			});
			if (slideshowSwiper.addSlide.length < 2) {
				slideshowSwiper.allowTouchMove = false;
			} else {
				slideshowSwiper.allowTouchMove = true;
			}
			if (slideshowSwiper.addSlide.length > 1)
				slideshow.classList.add("slideshow__swiper--multiple-slides");
		});
	};

	initSliders();

	document.addEventListener("shopify:section:load", function () {
		initSliders();
	});
})();
